const offlineAlarm = {
  AlarmInfo: "ข้อมูลการแจ้งเตือน",
  Type: "ประเภท",
  faultTime: "เวลาผิดพลาด",
  startTime: "เวลาเริ่มต้น",
  endTime: "เวลาสิ้นสุด",
  type1: "ถอดปลั๊กอุปกรณ์",
  type2: "นาฬิกาปลุกออฟไลน์"
} 
export default offlineAlarm